import $ from 'jquery';
import Backbone from 'backbone';
import template from '../templates/sticky.html';

const NoticesStickyView = Backbone.View.extend({
  events: {
    'click #notice-sticky-container': 'open',
  },

  initialize(options) {
    this.options = options || {};
  },

  render() {
    this.$el.append(template(this.options.noticeData));
    $('#notice-sticky-container').show();
  },

  open() {
    if (this.options.openCallback) {
      this.options.openCallback();
      this.hide();
    }
  },

  hide() {
    $('#notice-sticky-container').hide();
  },

  close() {
    this.hide();
    this.$el.empty().off();
  },
});

export default NoticesStickyView;



/** WEBPACK FOOTER **
 ** ./src/views/sticky.js
 **/